export default __webpack_public_path__ + "static/media/pattern-1.31181987.png";